export default {
  trainAddrDetailInfo: '/v3/rainAddresses/trainAddrDetailInfo'
}
